
// import { Channel } from 'src/app/models/channel';
import { Chapter } from 'src/app/models/chapter';
import { Live } from 'src/app/models/live';

import { HourMinSec } from 'src/app/pipes/hourminsec';

import HexRgb from 'hex-rgb';
import { UserVideo } from 'src/app/models/user-video';

export class PlayerHelper {

  userVideo:UserVideo;
  player:any; //　jwplayerインスタンス
  
  jwPlayerContainer:HTMLElement; // JWPlayerのelement
  jwWrapperContainer:HTMLElement; // .jw-wrapper
  jwControlsContainer: HTMLElement; // .jw-controls
  jwButtonContainer: HTMLElement; // .jw-button-container
  jwSettingContainer: HTMLElement; // .jw-icon-settings
  jwSliderContainer: HTMLElement; // .jw-slider-container
  jwControlbarContainer: HTMLElement; // .jw-controlbar

  onerollControlsContainer: HTMLElement; // .oneroll-controls-container
  onerollControlsRightTopContainer: HTMLElement; // .oneroll-controls-right-top-container

  controlsInnerCtaContainer: HTMLElement; // .overlay-cta-btn

  // option
  speedOverlayContainer: HTMLElement; // .oneroll-button-overlay.speed
  chapterContainer: HTMLElement; // .oneroll-chapter-container

  constructor(userVideo, player){

    this.userVideo = userVideo;
    this.player = player;

    this.jwPlayerContainer = this.player.getContainer();
    this.jwWrapperContainer = this.jwPlayerContainer.querySelector('.jw-wrapper');
    this.jwControlsContainer = this.jwPlayerContainer.querySelector('.jw-controls');
    this.jwButtonContainer = this.jwPlayerContainer.querySelector('.jw-button-container');
    this.jwSettingContainer = this.jwButtonContainer.querySelector('.jw-icon-settings');
    this.jwSliderContainer = this.jwPlayerContainer.querySelector(".jw-slider-container");
    this.jwControlbarContainer = this.jwPlayerContainer.querySelector(".jw-controlbar");
  
    this.onerollControlsContainer = document.createElement('div');
    this.onerollControlsContainer.setAttribute('class', 'oneroll-controls-container');
    this.jwPlayerContainer.appendChild(this.onerollControlsContainer);

    this.onerollControlsRightTopContainer = document.createElement('div');
    this.onerollControlsRightTopContainer.classList.add('oneroll-controls-right-top-container');
    this.onerollControlsContainer.appendChild(this.onerollControlsRightTopContainer);

    if(this.userVideo.ctaSimple){
      if('ontouchend' in document){
        this.jwWrapperContainer.addEventListener("touchend", () => { 
          if(this.userVideo.ctaSimple.isShown){
            setTimeout(() => {
              if(this.player.getState() == 'playing'){
                this.hideCta();
              }
              else{
                this.showCta();
              }  
            }, 100);
          }
        });
      }
      else{
        window.addEventListener('mouseover', () => {
          if(this.userVideo.ctaSimple.isShown){
            this.showCta();
          }
        });
        window.addEventListener('mouseout', () => {
          if(this.userVideo.ctaSimple.isShown){
            this.hideCta();
          }
        });
      }
    }

    this.controlsInnerCtaContainer = document.createElement('div');
    this.controlsInnerCtaContainer.classList.add('overlay-cta-btn');
    this.controlsInnerCtaContainer.classList.add('disable');
    this.onerollControlsRightTopContainer.appendChild(this.controlsInnerCtaContainer);

    if(! userVideo.live){
      this.initPlayFoward();
      this.initChangePlaySpeed();
    }

    this.initFullScreen();
    this.initCta();
  }

  // 10秒戻るボタンの後に10秒進むボタン追加 ////////////////////////////
  initPlayFoward(){
    var rewindElement = this.jwButtonContainer.querySelector('.jw-icon-rewind');
    rewindElement.innerHTML = '<mat-icon class="material-icons mat-icon notranslate material-icons mat-icon-no-color">replay_10</mat-icon>';
    var tmpFowardWrapperElement = document.createElement('div');
    tmpFowardWrapperElement.innerHTML = '<div id="oneroll-control-button-forward" class="jw-icon jw-icon-inline jw-button-color jw-reset jw-icon-forword" role="button" tabindex="0" style=""><mat-icon class="material-icons mat-icon notranslate material-icons mat-icon-no-color">forward_10</mat-icon></div>';
    var fowardWrapperElement = tmpFowardWrapperElement.firstElementChild;
    this.jwButtonContainer.insertBefore(fowardWrapperElement, rewindElement.nextElementSibling);
    var forward = () => {
      var currentPosition = this.player.getPosition();
      this.player.seek(currentPosition + 10);
    };
    fowardWrapperElement.addEventListener("click", () => { forward(); });
    fowardWrapperElement.addEventListener("touchstart", () => { forward(); });    

    // keydown(Enter)でforward()を実行
    fowardWrapperElement.addEventListener("focus", () => { fowardWrapperElement.classList.add("jw-tab-focus"); });
    fowardWrapperElement.addEventListener("blur", () => { fowardWrapperElement.classList.remove("jw-tab-focus"); });
    document.addEventListener("keydown", event => {
      if(event.key !== "Enter"){
        return;
      }
      if(! document.activeElement.getAttribute("id") || document.activeElement.getAttribute("id") != fowardWrapperElement.getAttribute("id")){
        return;
      }
      event.stopPropagation();
      forward();
    }, true); // 第3引数のuseCaptureをtrueにすることでイベントの優先順位を先にする    
  }

  // settingボタンの前に再生スピード変更ボタン追加 ////////////////////////////
  initChangePlaySpeed(){
    var tmpSpeedWprapperContainer = document.createElement('div');
    tmpSpeedWprapperContainer.innerHTML = '\
    <div class="jw-icon-speed jw-icon jw-icon-inline jw-button-color jw-reset" role="button" tabindex="0" style="">\
      <div class="oneroll-button speed">\
        <span id="oneroll-button-speed-label">1x</span>\
      </div>\
      <div class="oneroll-button-overlay speed">\
        <ul>\
          <li data-speed="0.5">0.5x</li>\
          <li data-speed="0.75">0.75x</li>\
          <li data-speed="1.0" class="selected">1x</li>\
          <li data-speed="1.25">1.25x</li>\
          <li data-speed="1.5">1.5x</li>\
          <li data-speed="1.75">1.75x</li>\
          <li data-speed="2.0">2x</li>\
        </ul>\
      </div>\
    </div>';
    var speedWrapperContainer = tmpSpeedWprapperContainer.firstElementChild;
    this.speedOverlayContainer = speedWrapperContainer.querySelector('.oneroll-button-overlay.speed');
    this.jwButtonContainer.insertBefore(speedWrapperContainer, this.jwSettingContainer.previousElementSibling);

    var speedButtonContainer = speedWrapperContainer.querySelector('.oneroll-button.speed');
    speedButtonContainer.addEventListener("click", (event) => {
      this.openSpeedList(event);
    });

    var speedLiElements = this.speedOverlayContainer.querySelectorAll('ul li');

    const changeSpeed = (selectedSpeedLiElement) => {
      // 対象再生速度以外の速度からselectedクラスを外す
      for(var i = 0; i < speedLiElements.length; i++){
        var speedLiElement = speedLiElements[i];
        speedLiElement.classList.remove("selected");
      }
      // 再生速度を変更
      selectedSpeedLiElement.classList.add("selected");  
      var speed = parseFloat(selectedSpeedLiElement.getAttribute("data-speed"));
      this.player.setPlaybackRate(speed);
      var buttonSpeedLabelElement = speedButtonContainer.querySelector("#oneroll-button-speed-label");
      buttonSpeedLabelElement.innerHTML = selectedSpeedLiElement.innerText;
    };
    for(var i = 0; i < speedLiElements.length; i++){
      var speedLiElement = speedLiElements[i];
      speedLiElement.addEventListener("click", (event) => { 
        var selectedSpeedLiElement = (event.target as HTMLElement);
        changeSpeed(selectedSpeedLiElement);
      });
    }

    // ・kewdown(up, down)で上下を移動
    // ・keydown(enter)で決定
    // ・keydown(escape)で閉じる

    // keydown(Enter)でforward()を実行

    // Focus当たったら
    // ・jw-tab-focusクラスつける
    // ・スピードリストを開く
    // ・keydown(enter)でforward()を実行
    const speedOverlayKeyDownEvent = (event) => {
      if(event.key != "ArrowDown" && event.key != "ArrowUp"){
        return;
      }
      event.stopPropagation();
      // 現在のSpeedIndexを取得
      for(let index = 0; index < speedLiElements.length; index++){
        const speedLiElement = speedLiElements[index];
        console.log(speedLiElement);
        // 小数点は最大2桁なので100倍して小数点を削除してから比較
        if(Math.floor(this.player.getPlaybackRate() * 100) != Math.floor(Number(speedLiElement.getAttribute("data-speed")) * 100)){
          console.log(this.player.getPlaybackRate().toString());
          continue;
        }

        let nextIndex = Number(index);
        if(event.key == "ArrowDown"){
          nextIndex += 1;
        }
        else if(event.key == "ArrowUp"){
          nextIndex += -1;
        }

        if(nextIndex >= 0 && nextIndex < speedLiElements.length){
          var selectedSpeedLiElement = speedLiElements[nextIndex];
          changeSpeed(selectedSpeedLiElement);  
        }
      }
    };
    speedWrapperContainer.addEventListener("focus", () => {
      this.speedOverlayContainer.classList.add('show');
      this.speedOverlayContainer.focus();
      this.speedOverlayContainer.classList.add("jw-tab-focus");
      document.addEventListener("keydown", speedOverlayKeyDownEvent);
    });
    speedWrapperContainer.addEventListener("blur", () => {
      document.removeEventListener("keydown", speedOverlayKeyDownEvent);
      this.speedOverlayContainer.classList.remove('show');
      this.speedOverlayContainer.classList.remove("jw-tab-focus");
    });
  }

  // 再生速度リスト表示
  private openSpeedList(event = null){
    if(this.jwControlsContainer.classList.contains('oneroll-settings-open')){
      this.closeSpeedList();
      return;
    }
    if(event){
      event.stopPropagation();
    }
    this.jwControlsContainer.classList.add('oneroll-settings-open');
    this.jwControlsContainer.classList.remove('jw-settings-open');
    this.speedOverlayContainer.classList.add('show');
    this.jwControlsContainer.addEventListener("click", () => {
      this.closeSpeedList();
    });
  };
  // 再生速度リスト非表示
  private closeSpeedList(){
    this.jwControlsContainer.classList.remove('oneroll-settings-open');
    this.speedOverlayContainer.classList.remove('show');
    this.jwControlsContainer.removeEventListener("click", this.closeSpeedList);
  };

  // 基本設定 ライブ再生の場合、必ず実行する ////////////////////////////////////////////////////////////////////////////////
  atacheCustomLiveSetting(){

    var hourMinSec = new HourMinSec();

    this.jwPlayerContainer.classList.add("oneroll-live");

    var buttonContainer = this.jwPlayerContainer.querySelector('.jw-button-container');

    var onerollControlsContainer = document.createElement('div');
    onerollControlsContainer.setAttribute('class', 'oneroll-controls-container');
    this.jwPlayerContainer.appendChild(onerollControlsContainer);

    var rewindButtonElement = buttonContainer.querySelector('.jw-icon-rewind');
    rewindButtonElement.parentNode.removeChild(rewindButtonElement);

    var timeTextElapsedElement = buttonContainer.querySelector('.jw-text-elapsed');
    timeTextElapsedElement.parentNode.removeChild(timeTextElapsedElement);

    var timeTextDurationElement = buttonContainer.querySelector('.jw-text-duration');
    timeTextDurationElement.parentNode.removeChild(timeTextDurationElement);
    
    // メニューに時間経過を表示
    var volumeElement = buttonContainer.querySelector('.jw-icon-volume');
    var tmpTimeLabelElement = document.createElement('div');
    tmpTimeLabelElement.innerHTML = '<div class="live-time-label">0:00</div>';
    var timeLabelElement = tmpTimeLabelElement.firstElementChild;
    buttonContainer.insertBefore(timeLabelElement, volumeElement.nextElementSibling);

    this.player.on('time', (data) => {
      var timeString = hourMinSec.transform(data.position);
      timeLabelElement.innerHTML = timeString;
    });

    // メニューにライブ中表示追加 ////////////////////////////
    var tmpLiveIconElement = document.createElement('div');
    tmpLiveIconElement.innerHTML = '<div class="live-icon"><span class="icon"></span><span class="text">LIVE</span></div>';
    var liveIconElement = tmpLiveIconElement.firstElementChild;
    buttonContainer.insertBefore(liveIconElement, timeLabelElement.nextElementSibling);

    // 左上にLIVEアイコン設置
    var liveIconContainer = document.createElement('div');
    liveIconContainer.setAttribute('class', 'live-icon-wrapper');
    var liveIconHtml = '\
      <span class="icon"></span><span class="text">LIVE</span>\
    ';
    liveIconContainer.innerHTML = liveIconHtml;
    onerollControlsContainer.appendChild(liveIconContainer);

    // キーイベントを上書きして削除
    this.jwPlayerContainer.addEventListener('keydown', (e) => e.stopImmediatePropagation(), true);
  }

  initChapter(chapterMode:"hidden" | "overlay" | "fixed", lang:any = "ja"){
    
    const duration = this.userVideo.time;
    const chapters = this.userVideo.chapters;

    if(! chapters || chapters.length == 0){
      return;
    }

    //////////////////////////////////////////////////////////////////////////////////////////
    // speedボタンの後にチャプターボタン追加 ////////////////////////////
    var tmpChapterBtnWprapperElement = document.createElement('div');
    tmpChapterBtnWprapperElement.innerHTML = '\
    <div id="oneroll-control-button-chapter" class="jw-icon-chapter jw-icon jw-icon-inline jw-button-color jw-reset" role="button" tabindex="0" style="">\
      <div class="oneroll-button chapter">\
        <span id="oneroll-button-chapter-label"><mat-icon class="material-icons mat-icon notranslate material-icons mat-icon-no-color">list</mat-icon></span>\
      </div>\
    </div>\
    ';
    var chapterBtnWprapperElement = tmpChapterBtnWprapperElement.firstElementChild;
    this.jwButtonContainer.insertBefore(chapterBtnWprapperElement, this.jwSettingContainer.previousElementSibling);

    var openChapter = (event) => {
      this.chapterContainer.classList.remove("close");

      // 他の開いている要素を閉じる
      this.jwControlsContainer.classList.remove('jw-settings-open');
      this.closeSpeedList();
      event.stopPropagation();
      this.jwPlayerContainer.addEventListener("click", closeChapter);
    };
    var closeChapter = (event) => {
      event.stopPropagation();
      this.chapterContainer.classList.add("close");
      this.jwPlayerContainer.removeEventListener("click", closeChapter);
    };
    chapterBtnWprapperElement.addEventListener("click", openChapter);

    // keydown(Enter)でforward()を実行
    chapterBtnWprapperElement.addEventListener("focus", () => { chapterBtnWprapperElement.classList.add("jw-tab-focus"); });
    chapterBtnWprapperElement.addEventListener("blur", () => { chapterBtnWprapperElement.classList.remove("jw-tab-focus"); });
    document.addEventListener("keydown", event => {
      if(event.key !== "Enter"){
        return;
      }
      if(! document.activeElement.getAttribute("id") || document.activeElement.getAttribute("id") != chapterBtnWprapperElement.getAttribute("id")){
        return;
      }
      event.stopPropagation();
      openChapter(event);
    }, true); // 第3引数のuseCaptureをtrueにすることでイベントの優先順位を先にする    

    var tmpChapterWrapperElement = document.createElement('div');
    var tmpChapterWrapperElementHtml = '\
    <div class="oneroll-slider-chapters">\
      <ul>\
    ';

    for(var i = 0; i < chapters.length; i++){
      var chapter = chapters[i];
      var startTime = chapter.time;
      var endTime;
      if(i < chapters.length - 1){
        var nextChapter = chapters[i + 1];
        endTime = nextChapter.time;
      }
      else{
        endTime = duration;
      }

      var width = ((endTime - startTime) / duration * 100) + "%";
      var left = (startTime / duration * 100) + "%";

      tmpChapterWrapperElementHtml += '\
      <li style="width:' + width + ';left:' + left + ';">\
        <div class="slider-chapter-container">\
          <span class="slider-chapter-progress"></span>\
          <span class="slider-chapter-bg"></span>\
        </div>\
      </li>\
      ';
    }
    tmpChapterWrapperElementHtml += '\
      </ul>\
    </div>\
    ';
    tmpChapterWrapperElement.innerHTML = tmpChapterWrapperElementHtml;
    var chapterWrapperElement = tmpChapterWrapperElement.firstElementChild;
    this.jwSliderContainer.appendChild(chapterWrapperElement);

    var tmpSliderTooltipWrapperElement = document.createElement('div');
    tmpSliderTooltipWrapperElement.innerHTML = '\
    <div class="oneroll-slider-tooltip-container">\
      <div class="oneroll-slider-tooltip">\
        <div class="chapter-title"></div>\
        <div class="time"></div>\
      </div>\
    </div>\
    ';
    var sliderTooltipWrapperElement = tmpSliderTooltipWrapperElement.firstElementChild as HTMLElement;
    this.jwControlbarContainer.appendChild(sliderTooltipWrapperElement);

    var sliderTooltipChapterTitleElement = sliderTooltipWrapperElement.querySelector(".chapter-title");
    var sliderContainerWidth;

    var showSliderTooltip = () => {
      sliderContainerWidth = this.jwSliderContainer.getBoundingClientRect().width;
      if(sliderTooltipWrapperElement.classList.contains("show")){
        return;
      }
      sliderTooltipWrapperElement.classList.add("show");
    };
    var hideSliderTooltip = () => {
      if(! sliderTooltipWrapperElement.classList.contains("show")){
        return;
      }
      sliderTooltipWrapperElement.classList.remove("show");
    };
    var moveSlider = (event) => {
      var clientX;
      if(event.targetTouches){ // for tablet
        clientX = event.targetTouches[0].clientX;
      }
      else {
        clientX = event.clientX;
      }
      sliderTooltipWrapperElement.style.left = clientX + "px";
      var time = Math.floor(clientX / sliderContainerWidth * duration);
      var timeString = hourMinSec.transform(time);
      sliderTooltipWrapperElement.querySelector(".time").innerHTML = timeString;

      for(var i = 0; i < chapters.length; i++){
        var chapter = chapters[i];
        var startTime = chapter.time;
        var endTime;
        if(i < chapters.length - 1){
          var nextChapter = chapters[i + 1];
          endTime = nextChapter.time;
        }
        else{
          endTime = duration;
        }

        if(startTime <= time && time < endTime){
          sliderTooltipChapterTitleElement.innerHTML = (i + 1) + ". " + (chapter.title as string);
        }
      }
    };

    this.jwSliderContainer.addEventListener("mouseover", (event) => { showSliderTooltip(); moveSlider(event); });
    this.jwSliderContainer.addEventListener("touchstart", (event) => { showSliderTooltip(); moveSlider(event); });
    this.jwSliderContainer.addEventListener("mouseout", () => { hideSliderTooltip(); });
    this.jwSliderContainer.addEventListener("touchend", () => { hideSliderTooltip(); });
    this.jwSliderContainer.addEventListener("mousemove", (event) => { moveSlider(event); });
    this.jwSliderContainer.addEventListener("touchmove", (event) => { moveSlider(event); });

    //////////////////////////////////////////////////////////////////////////////////////////
    // チャプター設置 ////////////////////////////
    this.chapterContainer = document.createElement('div');
    this.chapterContainer.setAttribute('class', 'oneroll-chapter-container');

    let chapterTitle;
    if(lang == "ja"){
      chapterTitle = "チャプター";
    }
    else{
      chapterTitle = "Chapter";
    }

    var hourMinSec = new HourMinSec();

    var chapterInnerHtml = '\
    <div class="chapter-close-btn"><span class="material-icons">close</span></div>\
    <div class="chapter-container">\
      <div class="chapter-header">\
        <div class="chapter-title">' + chapterTitle + '</div>\
      </div>\
    ';
    chapterInnerHtml += "<ul>";
    for(var i = 0; i < chapters.length; i++){
      var start = chapters[i].time;
      var end;
      if(i < chapters.length - 1){
        end = chapters[i + 1].time;
      }
      else{
        end = duration;
      }

      var chapter = chapters[i];
      chapterInnerHtml += '<li class="chapter-link" data-time="' + chapter.time + '">\
        <span class="title">' + chapter.title + '</span><br>\
        <span class="range">(' + hourMinSec.transform(start) + " ~ " + hourMinSec.transform(end) + ')</span>\
      </li>';
    }
    chapterInnerHtml += '</ul>\
    </div>';
    this.chapterContainer.innerHTML = chapterInnerHtml;
    this.jwPlayerContainer.appendChild(this.chapterContainer);

    const chapterLinkElements = this.jwPlayerContainer.querySelectorAll('.chapter-link');

    for(var i = 0; i < chapterLinkElements.length; i++){
      const chapterLinkElement = chapterLinkElements[i];
      chapterLinkElement.addEventListener("click", () => {
        this.chapterContainer.classList.add("close");
        const time = chapterLinkElement.getAttribute("data-time");
        this.player.seek(time);
        this.player.play();
      });
    }
    const chapterCloseBtnElement = this.jwPlayerContainer.querySelector('.chapter-close-btn');
    chapterCloseBtnElement.addEventListener("click", (event) => {
      this.chapterContainer.classList.add("close");
    });
    
    // デフォルトClose
    if(chapterMode == "overlay"){
      this.chapterContainer.classList.remove("close");
    }
    else{
      this.chapterContainer.classList.add("close");
    }

    // 右上のチャプターボタン
    var controlsInnerChapterHtml = '\
      <span class="material-icons">list</span>\
    ';
    var controlsInnerChapterElement = document.createElement('div');
    controlsInnerChapterElement.classList.add('chapter-open-btn');
    controlsInnerChapterElement.innerHTML = controlsInnerChapterHtml;
    this.onerollControlsRightTopContainer.appendChild(controlsInnerChapterElement);

    const chapterOpenBtnElement = this.jwPlayerContainer.querySelector('.chapter-open-btn');

    var openChapter = (event) => {

      // チャプター開く
      this.chapterContainer.classList.remove("close");

      // 他の開いている要素を閉じる
      this.jwControlsContainer.classList.remove('jw-settings-open');
  
      event.stopPropagation();
      this.jwPlayerContainer.addEventListener("click", closeChapter);
    };
    var closeChapter = (event) => {
      event.stopPropagation();
      this.chapterContainer.classList.add("close");
      this.jwPlayerContainer.removeEventListener("click", closeChapter);
    };
    chapterOpenBtnElement.addEventListener("click", openChapter);
  }  

  // FullScreen
  // Focus当たったら
  // ・jw-tab-focusクラスつける
  // ・keydown(enter)でrequestFullscreen()を実行
  initFullScreen(){
    var fullScreenBtnElement = document.querySelector(".jwplayer .jw-icon-fullscreen");
    if(! fullScreenBtnElement){
      return;
    }
    fullScreenBtnElement.setAttribute("id", "oneroll-control-button-fullscreen");
    // keydown(Enter)でforward()を実行
    fullScreenBtnElement.addEventListener("focus", () => { fullScreenBtnElement.classList.add("jw-tab-focus"); });
    fullScreenBtnElement.addEventListener("blur", () => { fullScreenBtnElement.classList.remove("jw-tab-focus"); });
    document.addEventListener("keydown", event => {
      if(event.key !== "Enter"){
        return;
      }
      if(! document.activeElement.getAttribute("id") || document.activeElement.getAttribute("id") != fullScreenBtnElement.getAttribute("id")){
        return;
      }
      event.stopPropagation();
      if(document.fullscreenElement){
        this.exitFullscreen();
      }
      else{
        this.fullscreen();
      }
    }, true); // 第3引数のuseCaptureをtrueにすることでイベントの優先順位を先にする        
  }

  fullscreen(isIphone = false){
    let targetElement = document.getElementById("app-root") as any;
    if(isIphone){
      // iPhoneの場合、targetElement.webkitRequestFullscreenがundefinedが返ってくるのでここでrequestする
      targetElement = document.querySelector("video.jw-video") as any;
      targetElement.webkitRequestFullscreen();
      return;
    }

    if(targetElement.requestFullscreen) {
      targetElement.requestFullscreen();
    } else if (targetElement.mozRequestFullScreen) {
      /* Firefox */
      targetElement.mozRequestFullScreen();
    } else if (targetElement.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      targetElement.webkitRequestFullscreen();
    } else if (targetElement.msRequestFullscreen) {
      targetElement.msRequestFullscreen();
    }
    else{

    }
  }
  exitFullscreen(){
    if(document.exitFullscreen){
      document.exitFullscreen();
    }
  }

  initCta(){ // CTAオブジェクト

    // 右上のCTAボタン
    var controlsInnerCtaHtml = '\
    <a target="_blank">\
      <div class="overlay-cta-btn-container">\
        <span class="overlay-cta-btn-text"></span>\
        <span class="material-icons">chevron_right</span>\
      </div>\
    </a>\
    ';

    this.controlsInnerCtaContainer.innerHTML = controlsInnerCtaHtml;

    // CTAがなければ以上で設定終了
    if(! this.userVideo.ctaSimple){
      return;
    }

    // ここからはCTAがあればCTAを設定
    const ctaSimple = this.userVideo.ctaSimple;

    const controlsInnerCtaAContainer = this.controlsInnerCtaContainer.querySelector('a');
    controlsInnerCtaAContainer.setAttribute('href', ctaSimple.linkUrl.toString());
    controlsInnerCtaAContainer.addEventListener('click', () => {
      const content = ctaSimple;

      console.log("CTA rightup");

      // CTA送信
      if(window.onerollq){
        // Trackに送信
        let data = {
          userVideoHashPublic: null,
          hash: content.hash,
          title: content.title,
          url:content.linkUrl,
        };
        data.userVideoHashPublic = this.userVideo.hashPublic;
        window.onerollq('CtaUpdate', data);
      }
  
    });

    const controlsInnerCtaTextContainer = this.controlsInnerCtaContainer.querySelector('.overlay-cta-btn-text');
    controlsInnerCtaTextContainer.innerHTML = ctaSimple.title.toString();
  }

  // disableクラスにより表示の許可を管理する
  enableCta(){
    this.controlsInnerCtaContainer.classList.remove('disable');
  }
  // disableクラスが付与されていない場合、showクラスにより表示の管理をする
  showCta(){
    this.controlsInnerCtaContainer.classList.add('show');
    if(! this.controlsInnerCtaContainer.classList.contains('already-shown')){
      setTimeout(() => {
        this.controlsInnerCtaContainer.classList.add('already-shown');
      }, 700);
    }
  }
  hideCta(){
    this.controlsInnerCtaContainer.classList.remove('show');
  }
  toggleCta(){
    if(this.controlsInnerCtaContainer.classList.contains('show')){
      this.hideCta();  
    }
    else{
      this.showCta();
    }
  }

  // hexColor ex: #ff9900
  static getPlayerCss(hexColor:string, hasChapter = false):string{

    // HEX -> RGB
    let color:any = (HexRgb(hexColor));

    const primaryColorNoAlpha = "rgba(" + color.red + "," + color.green + "," + color.blue + "," + 1.0 + ")";
    const primaryColor   = "rgba(" + color.red + "," + color.green + "," + color.blue + "," + 0.85 + ")";
    const secondaryColor = "rgba(" + color.red + "," + color.green + "," + color.blue + "," + 0.85 + ")";
    const thinColor = "rgba(" + color.red + "," + color.green + "," + color.blue + "," + 0.3 + ")";

    let style:string = '';
    style += '.primary-color { background-color: ' + primaryColorNoAlpha + ' !important; }';
    style += '.jwplayer .jw-display-controls .jw-display-icon-container { background-color: ' + primaryColor + '; }';
    style += '.jwplayer.jw-state-idle .jw-display-controls .jw-display-icon-container { background-color: ' + primaryColor + '; }';
    style += '.jwplayer.jw-state-idle .jw-display-controls .jw-display-icon-container:hover { background-color: ' + primaryColor + '; }';
    style += '.jwplayer .jw-controlbar { background-color: ' + secondaryColor + '; }';
    style += '.jwplayer .jw-controlbar .jw-tooltip.jw-open { color: ' + primaryColor + '; }';
    style += '.jwplayer .jw-controlbar .jw-tooltip .jw-text { background-color:' + primaryColor + '; }';
    style += '.jwplayer .jw-overlay .jw-slider-volume .jw-slider-container .jw-knob { background-color: ' + primaryColor + '; }';
    style += '.jwplayer .jw-controlbar .jw-slider-time .jw-slider-container .jw-buffer { background-color: ' + thinColor + '; }';
    style += '.jwplayer .jw-controlbar .jw-slider-time .jw-slider-container .jw-knob { background-color: ' + primaryColor + '; }';

    style += '.jwplayer .jw-controlbar .oneroll-slider-chapters .slider-chapter-progress { background-color: ' + primaryColor + '; }';
    if(hasChapter){
      style += '.jwplayer .jw-controlbar .jw-slider-time .jw-slider-container .jw-progress { background-color: ' + thinColor + '; }';
    }
    else{
      style += '.jwplayer .jw-controlbar .jw-slider-time .jw-slider-container .jw-progress { background-color: ' + primaryColor + '; }';
    }

    style += '.jwplayer .jw-settings-menu .jw-settings-topbar { border-bottom-color: ' + secondaryColor + '; }';
    style += '.jwplayer .jw-settings-menu .jw-settings-content-item:hover, .jwplayer .jw-settings-menu .jw-settings-item-active { color: ' + primaryColor + '; }';

    style += '.overlay-cta-btn-container:hover{ background-color: ' + primaryColorNoAlpha + ' !important;}';
    style += '@keyframes ctaOverlayShowAnimation {';
    style +=   '0% {';
    style +=     'background-color: #fff;';
    style +=     'color: #000;';
    style +=   '}';
    style +=   '100% {';
    style +=     'background-color: ' + primaryColor + ';';
    style +=     'color: #fff;';
    style +=   '}';
    style += '}';    

    return style;
  }
}